import { getField, updateField } from 'vuex-map-fields';
// const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  namespaced: true,
  state: {
  },
  mutations: {
    updateField,
  },
  actions: {
  },
  getters: { getField },
};
